const adv160Data = {
  slug: "adv-160",
  name: "Honda ADV 160",

  hero: {
    shortDescription:
      "Skutik petualang premium dengan tampilan gagah dan teknologi canggih untuk segala kondisi jalan",

    variants: [
      {
        key: "abs",
        label: "ABS",
        fullName: "Honda ADV 160 ABS Tough Matte Black",
        startPrice: 41152000,
      },
      {
        key: "cbs",
        label: "CBS",
        fullName: "Honda ADV 160 CBS Solid White",
        startPrice: 37459000,
      },
      {
        key: "roadsync",
        label: "RoadSync",
        fullName: "Honda ADV 160 ABS RoadSync SUV Brown",
        startPrice: 42808000,
      },
    ],

    slides: [
      {
        variantKey: "abs",
        image: "/assets/motor/produk/adv/Honda-ADV-160-ABS-Tough-Matte-Black-1.webp",
        specs: {
          engine: "156,9 cc, 4 Langkah, 4 Katup, SOHC, eSP+",
          power: "11,8 kW (16 PS) / 8.500 rpm",
          smartKey: true,
        },
      },
      {
        variantKey: "cbs",
        image: "/assets/motor/produk/adv/Honda-ADV-160-CBS-Solid-White.webp",
        specs: {
          engine: "156,9 cc, 4 Langkah, 4 Katup, SOHC, eSP+",
          power: "11,8 kW (16 PS) / 8.500 rpm",
          smartKey: true,
        },
      },
      {
        variantKey: "roadsync",
        image: "/assets/motor/produk/adv/Honda-ADV-160-ABS-RoadSync-SUV-Brown.webp",
        specs: {
          engine: "156,9 cc, 4 Langkah, 4 Katup, SOHC, eSP+",
          power: "11,8 kW (16 PS) / 8.500 rpm",
          smartKey: true,
        },
      },
    ],
  },

  description: {
    sections: [
      {
        type: "paragraph",
        text:
          "Honda ADV 160 hadir sebagai skutik berjiwa petualang dengan desain tangguh dan performa mesin bertenaga. Motor ini dirancang untuk pengendara yang menginginkan kenyamanan skutik premium dengan kemampuan jelajah lebih luas.",
      },
      {
        type: "paragraph",
        text:
          "Mengusung mesin 160cc 4 katup enhanced Smart Power Plus (eSP+), Honda ADV 160 menawarkan akselerasi responsif, efisiensi bahan bakar optimal, serta performa andal di berbagai kondisi jalan.",
      },
      {
        type: "heading",
        text: "Desain Adventure dan Fitur Premium",
      },
      {
        type: "paragraph",
        text:
          "Tampilan gagah Honda ADV 160 diperkuat dengan windshield tinggi yang dapat diatur, suspensi depan dengan sub tank, serta bodi kokoh yang memberikan kesan motor petualang sejati.",
      },
      {
        type: "heading",
        text: "Stabil, Aman, dan Nyaman",
      },
      {
        type: "paragraph",
        text:
          "Dilengkapi fitur keselamatan seperti ABS, Honda Selectable Torque Control (HSTC), serta Honda RoadSync pada tipe tertentu, ADV 160 memberikan rasa aman dan nyaman untuk perjalanan jarak dekat maupun jauh.",
      },
    ],
  },

  specificationsDetail: {
    mesin: [
      ["Tipe Mesin", "4 Langkah, 4 Katup, SOHC, eSP+, Pendingin Cairan"],
      ["Sistem Suplai Bahan Bakar", "PGM-FI"],
      ["Kapasitas Mesin", "156,9 cc"],
      ["Daya Maksimum", "11,8 kW (16 PS) / 8.500 rpm"],
      ["Torsi Maksimum", "14,7 Nm / 6.500 rpm"],
      ["Transmisi", "Otomatis, V-Matic"],
    ],

    rangka: [
      ["Tipe Rangka", "enhanced Smart Architecture Frame (eSAF)"],
      ["Suspensi Depan", "Teleskopik dengan Sub Tank"],
      ["Suspensi Belakang", "Suspensi Belakang Ganda"],
      ["Rem Depan", "Cakram Hidrolik"],
      ["Rem Belakang", "Cakram"],
    ],

    dimensi: [
      ["Panjang x Lebar x Tinggi", "1.950 x 763 x 1.196 mm"],
      ["Tinggi Jok", "780 mm"],
      ["Jarak Sumbu Roda", "1.324 mm"],
      ["Berat", "133–135 kg"],
    ],

    kapasitas: [
      ["Kapasitas Tangki Bahan Bakar", "8,1 Liter"],
      ["Kapasitas Bagasi", "30 Liter"],
    ],

    kelistrikan: [
      ["Sistem Pengapian", "Full Transistorized"],
      ["Tipe Aki", "12V MF"],
      ["Sistem Starter", "Electric Starter"],
    ],
  },

  fullFeatures: {
    title: "Fitur Unggulan Honda ADV 160",
    items: [
      {
        title: "Mesin 160cc eSP+",
        desc:
          "Mesin generasi terbaru dengan performa bertenaga, halus, dan efisiensi bahan bakar optimal.",
      },
      {
        title: "Adjustable Windshield",
        desc:
          "Windshield depan yang dapat diatur ketinggiannya untuk kenyamanan berkendara di berbagai kondisi.",
      },
      {
        title: "Honda Smart Key System",
        desc:
          "Sistem keyless dengan alarm dan answer back system untuk keamanan maksimal.",
      },
      {
        title: "Anti-Lock Braking System (ABS)",
        desc:
          "Sistem pengereman ABS untuk mencegah roda terkunci saat pengereman mendadak. *Tersedia pada tipe ABS dan RoadSync.",
      },
      {
        title: "Honda RoadSync",
        desc:
          "Konektivitas pintar dengan smartphone untuk navigasi dan notifikasi. *Tersedia pada tipe RoadSync.",
      },
      {
        title: "Honda Selectable Torque Control (HSTC)",
        desc:
          "Sistem kontrol traksi untuk menjaga kestabilan roda belakang di jalan licin.",
      },
      {
        title: "Panel Meter Digital",
        desc:
          "Panel meter digital informatif dengan tampilan modern dan mudah dibaca.",
      },
      {
        title: "USB Charger",
        desc:
          "Port USB untuk pengisian daya perangkat elektronik saat berkendara.",
      },
    ],
  },
};

export default adv160Data;
